import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 12px;
`;

export const ScanIMEINumber = styled.div`
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #040222;
`;

export const SplitFlex = styled.div`
    display: flex;
    margin-top: 20px;
`;

export const Hr = styled.div`
    display: flex;
    flex: 5;
    align-items: center;
    margin-top: 8px;
    width: 100%;
    height: 0px;
    border: 1px solid #e7e7f0;
`;

export const OrText = styled.div`
    display: flex;
    flex: 1;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    align-items: center;
    color: #5b5675;
    justify-content: center;
`;

export const InputWrapper = styled.div`
    display: flex;
    margin-top: 32px;
`;

export const VerifiedIMEI = styled.div`
    display: flex;
    margin-top: 5px;
`;

export const CheckBoxFlex = styled.div`
    display: flex;
    align-items: center;
    margin-top: 2px;
`;

export const ConfirmationText = styled.div`
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    margin-left: 10px;
`;

export const ButtonWrapper = styled.div`
    margin: 25px 0;
`;

export const LoaderTextWrapper = styled.div`
    text-align: center;
    padding-top: 8px;
    font-size: 12px;
    color: #666;
    font-style: italic;
`;
